var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1301.4252 1301.4252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;fill:url(#Gradiente_sem_nome);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome",
    x1: -65909.97307,
    y1: 75571.31008,
    x2: -65909.97307,
    y2: 68670.08156,
    gradientTransform: "matrix(0.19834, 0, 0, -0.19834, 13881.43872, 15576.07795)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M809.0001,599.28757c359.378,0,650.7126,291.33459,650.7126,650.7126s-291.33459,650.71259-650.7126,650.71259-650.7126-291.33458-650.7126-650.71259S449.62209,599.28757,809.0001,599.28757Z",
    transform: "translate(-158.2875 -599.28757)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M893.54933,1895.25034V1392.62867h141.69841l18.78243-176.89949H893.549l.23785-88.54582c0-46.13949,4.38318-70.85037,70.6559-70.85037h88.59346V879.40367H911.306c-170.24317,0-230.15513,85.81093-230.15513,230.13925v106.19981H575.0262v176.91538H681.15086v495.46563a656.14083,656.14083,0,0,0,212.3977,7.1266Z",
    transform: "translate(-158.2875 -599.28757)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIc);
export default __webpack_public_path__ + "static/media/facebook-ic.847d4478f43b5039a02f0e69a9650195.svg";
export { ForwardRef as ReactComponent };